import { connect } from "react-redux";
import {
  Card,
  Text,
  Image
} from './styles'
import logoBig from "../../../../assets/logo.svg";
import { useEffect, useMemo, useState } from "react";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { useLocation } from "react-router-dom";
import constants from "../../../../constants";



const Component = ({ group, groupStates, post, user }) => {
  const { isMobile } = useWindowSize()
  const location = useLocation();
  const [currentPageLocally, setCurrentPageLocally] = useState<any>();

  const groupInfo = useMemo(() => {
    return group || post?.group;
  }, [group, post]);

  const isOwnGroup = useMemo(() => {
    const expertId = groupInfo?.expert?.id
    return expertId === user?.expert?.id;
  }, [groupInfo, user]);

  useEffect(() => {
    const page =
      location &&
      constants.pages.filter((page) => {
        return location.pathname.match(page.regex);
      });
    setCurrentPageLocally(page[0]);
  }, [location]);

  if (!group || !groupInfo?.expert?.hide_powered_by_klouser || !user || !isOwnGroup) {
    return <></>
  }

  // Para GROUP_DETAILS: siempre mostrar si cumple las condiciones
  if (currentPageLocally?.name === "GROUP_DETAILS" && !groupInfo?.expert?.hide_powered_by_klouser && (user?.expert?.big_logo || user?.expert?.small_logo)) {
    return <></>
  }

  // Para GROUP_POST_PREVIEW: mostrar si NO es free Y NO es de grupo community
  if (currentPageLocally?.name === "GROUP_POST_PREVIEW" &&
    !groupInfo?.expert?.hide_powered_by_klouser &&
    !post?.is_free && post?.group?.group_type !== "community") {
    return <></>
  }


  // Para GROUP_POST_PREVIEW: mostrar si NO es free Y NO es de grupo community
  if (currentPageLocally?.name === "GROUP_POST_PREVIEW" &&
    !groupInfo?.expert?.hide_powered_by_klouser &&
    !post?.is_free && post?.group?.group_type !== "community") {
    return <></>
  }



  return (
    <>
      <Card>
        <Text>En colaboración con</Text>
        <a href="/" style={{ display: 'block' }}>
          <Image src={logoBig} alt="Klouser" loading="lazy" />
        </a>
      </Card>
      {isMobile && <div style={{ height: 5 }} />}
    </>
  )
};


const state = ({ groupStore, userStore, postStore }) => {
  const { data: group, states: groupStates } = groupStore.group;
  const { data: user } = userStore.information;
  const { data: post } = postStore.post;

  return {
    group,
    groupStates,
    user,
    post
  };
};

export default connect(state)(Component);
